<template>
<section class="input-container">
    <div class="label">
        <p><i class="icon-required" v-if="transProp.validations.presence === '1'">*</i>{{transProp.label}}:</p>
        <van-icon name="question-o" class="question" v-if="transProp.notes" @click="showNotes" />
    </div>
    <div class="inp-f">
        <van-uploader :before-read="beforeRead" :after-read="afterRead">
            <div class="upload">点击上传</div>
        </van-uploader>
    </div>
    <div class="form-error" v-show="showError">
        {{transProp.label}}不可为空
    </div>
    <div class="tip">※ 请您上传jpg、png、jpeg或gif格式，单张图片不超过5M，总数不超过15张</div>
    <ul class="file-list">
        <li v-for="(item, index) in fileList">
            <div class="filename">{{item.file.name}}({{item.size}}m)</div>
            <div class="delete" @click="deleteFile(index)">删除</div>
        </li>
    </ul>
</section>
</template>

<script>
import { Uploader, Icon, Toast } from "vant";
import fetchData from "@/utils/fetch";
import { promisify } from 'util';
export default {
  props: {
    transProp: Object,
    index: Number
  },
  components: {
    "van-uploader": Uploader,
    "van-icon": Icon
  },
  data() {
    return {
      fileList: [],
      ajaxFileList: [],
      showError: false
    };
  },
  methods: {
    showNotes() {
      this.$emit("input", this.index);
    },
    collectOptions() {
      let options = {
        code: this.transProp.code,
        value: this.ajaxFileList
      };
      return options;
    },
    calSize(size) {
      return (size / 1024 / 1024).toFixed(2);
    },
    setOptions() {
      let options = {};
      let qucParams = ['qid', 'timestamp', 'src', 'ukey', 'fkey'];
      const params = new URLSearchParams(location.search);
      qucParams.forEach(item => {
          let param = params.get(item);
          if (param) {
              options[item] = param;
          }
      });
      return options;
    },
    beforeRead(file) {
      return new Promise((resolve, reject) => {
        let formats = [
        "image/jpg",
        "image/jpeg",
        "image/png",
        "image/gif",
        "image/zip",
        "image/rar"
      ];
      if (!formats.includes(file.type)) {
        Toast("请上传正确的图片格式");
        reject(false)
      }
      if (this.calSize(file.size) > 5) {
        Toast("图片大小不可超过5M");
        reject(false);
      }
      if (this.fileList.length > 14) {
        Toast("图片数量不可超过15张");
        reject(false);
      }
      let formData = new FormData();
      formData.append("file", file);
      let specialOptions = this.setOptions();
      Object.keys(specialOptions).forEach(item => {
        formData.append(item, specialOptions[item])
      })
      fetchData("uploadAttachments", formData)
        .then(result => {
          if (result) {
            this.ajaxFileList.push(result.data);
            resolve(true);
          } else {
            reject(false);
          }
        })
        .catch(err => {});
      });
    },
    afterRead(file) {
      let files = {
        file: file.file,
        size: this.calSize(file.file.size)
      };
      this.fileList.push(files);
      this.validate();
    },
    deleteFile(i) {
      this.fileList = this.fileList.filter((item, index) => i !== index);
      this.validate();
    },
    validate() {
      if (this.transProp.required) {
        if (!this.fileList.length) {
          this.showError = true;

          return { label: this.transProp.label, boo: true };
        } else {
          this.showError = false;
          return { label: this.transProp.label, boo: false };
        }
      } else {
        return { label: this.transProp.label, boo: false };
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.input-container {
  .label {
    display: flex;
    align-items: center;
    justify-content: space-between;

    .question {
      color: #999090;
      font-size: 32px;
    }
  }

  .tip {
    color: #666;
    line-height: 1.4;
    font-size: 24px;
  }

  .inp-f {
    margin: 8px 0;

    .upload {
      width: 272px;
      height: 64px;
      border: 2px solid #d9d9d9;
      border-radius: 2px;
      line-height: 64px;
      color: #666;
      text-align: center;
    }
  }

  .file-list {
    li {
      margin-top: 12px;
      color: #666;
      display: flex;
      justify-content: space-between;
      font-size: 24px;
    }
  }
}
</style>
